var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-switch',{attrs:{"input-value":_vm.value,"label":_vm.config.label},on:{"change":function($event){_vm.input($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }